'use client';

import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

type RequiredFieldsLegendProps = {
    className?: string;
};

/**
 * Visible legend explaining that `*` marks required fields.
 * Place as the first child of a `<form>` (before the first field).
 */
export function RequiredFieldsLegend({ className }: RequiredFieldsLegendProps) {
    const { t } = useTranslation('common');

    return <p className={cn('body-copy-s text-muted-foreground', className)}>{t('requiredFieldsLegend')}</p>;
}

/**
 * Visual asterisk for required field labels and required consent copy.
 * Rendered via CSS `content` so it does not change the label’s accessible name
 * (keeps `getByLabelText` / screen-reader names stable); `aria-hidden` excludes it from AT.
 */
export function RequiredMarker({ className }: { className?: string }) {
    return <span aria-hidden="true" className={cn("ps-0.5 after:content-['*']", className)} />;
}
